var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3791 13.9309L15.7485 0.310211C15.6504 0.211875 15.5338 0.133859 15.4055 0.080629C15.2771 0.0273991 15.1396 0 15.0006 0C14.8617 0 14.7241 0.0273991 14.5958 0.080629C14.4675 0.133859 14.3509 0.211875 14.2527 0.310211L0.62213 13.9309C0.225026 14.328 0 14.8674 0 15.43C0 16.5981 0.949741 17.5479 2.11789 17.5479H3.55409V27.267C3.55409 27.8527 4.0273 28.3259 4.61303 28.3259H12.8827V20.9133H16.589V28.3259H25.3882C25.9739 28.3259 26.4472 27.8527 26.4472 27.267V17.5479H27.8834C28.4459 17.5479 28.9853 17.3261 29.3824 16.9257C30.2064 16.0984 30.2064 14.7582 29.3791 13.9309Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.94a7a4e89f38d743d1a691e5c33eced7.svg";
export { ForwardRef as ReactComponent };